exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "ul.fleet-list{display:flex;flex-flow:row;justify-content:center}.fleet-list li{padding:10pt;font-size:24px}@media and (max-width:768px){ul.fleet-list li{flex-basis:50%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// C:/PhpstormProjects/e-crewing/~/css-loader?minimize!C:/PhpstormProjects/e-crewing/~/vue-loader/lib/style-rewriter.js?id=data-v-304ccebc!C:/PhpstormProjects/e-crewing/~/vue-loader/lib/selector.js?type=styles&index=0!./vue/fleet/components/Fleets.vue
// module id = 117
// module chunks = 3